
import { TranslationRecord } from '../../types';

export const footer: TranslationRecord = {
  // Footer
  quickLinks: 'Quick Links',
  privacyPolicy: 'Privacy Policy',
  rentalConditions: 'Rental Conditions',
  cookiePolicy: 'Cookie Policy',
  faq: 'FAQ',
  allRightsReserved: 'All Rights Reserved',
  legalHelp: 'Legal & Help',
  footerDescription: 'Located in the vibrant center of Thessaloniki, Loena Luxury Suites offers premium accommodation with a blend of modern luxury and comfort.',
  // Company Information
  companyInfo: 'Company Information',
  companyName: 'Company Name: Christos Ath. Petkakis & Co.',
  vatId: 'VAT ID',
  vatNumber: 'EL092615293',
  address: 'Address',
  companyAddress: '13 Ernestou Emprar Street, 4th Floor, Thessaloniki 54625',
  gemi: 'Greek Commercial Registry',
  gemiNumber: '038228205000',
};
